import React from "react";
import { motion } from "framer-motion";

const SpinningSVG = () => {
  return (
    <motion.svg
      width="90"
      height="90"
      fill="none"
      viewBox="0 0 200 200"
      style={{ verticalAlign: "middle" }}
      animate={{ rotate: 360 }}
      transition={{ repeat: Infinity, duration: 10, ease: "linear" }}
    >
      <g clipPath="url(#clip0_116_92)">
        <path
          fill='url("#SvgjsLinearGradient1079")'
          d="M127.233 110.308c18.623 7.05 43.69 5.765 59.65-3.058L200 100l-13.117-7.25c-15.96-8.823-41.026-10.107-59.65-3.058l-13.966 5.286c-.087-.281-.192-.553-.295-.826l13.574-6.12c18.154-8.184 34.969-26.817 40.017-44.341l4.148-14.402-14.402 4.148c-17.524 5.047-36.157 21.863-44.342 40.017l-5.91 13.11a13.937 13.937 0 0 0-.828-.379l5.079-13.419c7.049-18.623 5.764-43.69-3.058-59.65L100 0l-7.25 13.117c-8.823 15.96-10.107 41.026-3.058 59.65l5.079 13.419c-.283.114-.556.246-.828.379l-5.91-13.111C79.847 55.3 61.214 38.484 43.69 33.437L29.289 29.29l4.148 14.402C38.484 61.215 55.3 79.848 73.454 88.033l13.573 6.12c-.102.273-.208.544-.294.826l-13.967-5.287c-18.623-7.05-43.69-5.764-59.65 3.058L0 100l13.117 7.25c15.96 8.823 41.026 10.108 59.65 3.058l14.62-5.533c.114.252.23.505.36.749l-14.293 6.444c-18.153 8.184-34.97 26.817-40.017 44.341l-4.148 14.402 14.402-4.148c17.524-5.047 36.157-21.863 44.342-40.016l6.633-14.713c.245.102.5.186.751.275l-5.725 15.125c-7.05 18.623-5.764 43.69 3.058 59.65l7.25 13.117 7.251-13.117c8.822-15.96 10.107-41.026 3.058-59.65l-5.726-15.126c.252-.088.507-.172.752-.275l6.633 14.713c8.184 18.154 26.817 34.969 44.341 40.017l14.402 4.148-4.148-14.402c-5.047-17.524-21.863-36.157-40.016-44.342l-14.294-6.443c.13-.244.246-.497.361-.75l14.619 5.534Z"
        ></path>
      </g>
      <defs>
        <linearGradient
          gradientTransform="rotate(0 0.5 0.5)"
          id="SvgjsLinearGradient1079"
        >
          <stop stopColor="rgba(105, 234, 203)" offset="0"></stop>
          <stop stopColor="rgba(234, 204, 248)" offset="0.48"></stop>
          <stop stopColor="rgba(255, 102, 0)" offset="1"></stop>
        </linearGradient>
      </defs>
    </motion.svg>
  );
};

export default SpinningSVG;
